/**
 * Claire failure groups (ENG-2086) - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 *
 * Where a group is in its fix: found (open), being fixed, fix deployed and
 * being watched, or done. A closed group that gets a new confirmed failure
 * goes back to open.
 */
export const claireFailureGroupStatusLabels = {
    open: 'Needs a fix',
    fixing: 'Fix in progress',
    fixed: 'Fix shipped',
    closed: 'Closed',
};
export const claireFailureGroupStatusValues = Object.keys(claireFailureGroupStatusLabels);
//# sourceMappingURL=claire-failure-groups.js.map